import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { isAdmin } from '../../utils/roleCheck';

/**
 * AdminRoute - Protects routes that should only be accessible by admin users
 *
 * Admin users are identified by:
 * 1. Email: uk@health.org
 * 2. Public metadata role: 'admin'
 *
 * If user is not admin, redirects to /chat
 */
const AdminRoute = ({ children }) => {
  const { user, isLoaded } = useUser();

  // Show loading state while Clerk is loading
  if (!isLoaded) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        fontSize: '1.2rem',
        color: 'var(--text-primary)'
      }}>
        Loading...
      </div>
    );
  }

  // Check if user is admin
  if (!isAdmin(user)) {
    // Not admin - redirect to chat
    return <Navigate to="/chat" replace />;
  }

  // User is admin - render the protected component
  return children;
};

export default AdminRoute;
